<template>
  <div class="foters">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="账户姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                v-model="accountName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="套餐名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                :allowClear="true"
                v-model="pgName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item
              label="订单状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                :allowClear="true"
                v-model="orderStatus"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="item in orderStatuss"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item
              label="支付方式"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                :allowClear="true"
                v-model="payType"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="item in orderPayTypes"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="4" class="oper">
            <div style="height: 41px; line-height: 41px">
              <a-button
                class="btone"
                style="margin-left: 10px"
                @click="queryDataFn(1)"
                >查询</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :data-source="tableData"
        :loading="spinning"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            index + (pageNum - 1) * pageSize + 1
          }}
        </span>
        <span slot="payType" slot-scope="text">
          <span v-if="text == 1"
            ><a-badge color="cyan" /></span>
            <span v-else-if="text == 2"
              ><a-badge color="cyan"
            /></span>
            <span v-else-if="text == 3"
              ><a-badge color="orange"
            /></span>
          {{ text | DictionaryFilter("ORDER_PAY_TYPE") }}
        </span>
        <span slot="orderStatus" slot-scope="text">
            <span v-if="text == 1"
            ><a-badge color="cyan" /></span>
            <span v-else-if="text == 2"
              ><a-badge color="orange"
            /></span>
            <span v-else-if="text == 3"
              ><a-badge color="orange"
            /></span>
            <span v-else-if="text == 5"
              ><a-badge color="red"
            /></span>
          {{ text | DictionaryFilter("ORDER_STATUS") }}
        </span>
        <span slot="orderGoodsType" slot-scope="text">
          {{ text | DictionaryFilter("ORDER_GOODS_TYPE") }}
        </span>
        <span slot="createTime" slot-scope="text" :title="toDate(text)">
          {{ toDate(text) }}
        </span>
        <template slot="operation" slot-scope="text, record">
          <a-button
            href="javascript:;"
            class="btaction"
            @click="jumpDetailsFn(record)"
            >详情</a-button
          >
        </template>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { qcpQuery } from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");
export default {
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      formLayout: "horizontal",
      pageNum: 1,
      pageSize: 10,
      totalRows:0,
      totalPages:0,
      orderBy: "",
      accountName: "",
      pgName: "",
      orderStatus: undefined,
      payType: undefined,
      spinning: false,
      orderPayTypes: [],
      orderStatuss: [],
      orderGoodsTypes: [],
      tableData: [],
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 50,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "订单编号",
          dataIndex: "orderNo",
          key: "orderNo",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderNo" },
        },
        {
          title: "账户姓名",
          dataIndex: "accountName",
          width: 80,
          key: "accountName",
          align: "center",
          ellipsis: true,
          scopedSlots: { customRender: "accountName" },
        },
        {
          title: "套餐名称",
          dataIndex: "pgName",
          align: "center",
          key: "pgName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "pgName" },
        },
        {
          title: "套餐类型",
          dataIndex: "orderGoodsType",
          key: "orderGoodsType",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderGoodsType" },
        },
        {
          title: "购买数量",
          dataIndex: "buyNum",
          key: "buyNum",
          align: "center",
          ellipsis: true,
          width: 60,
          scopedSlots: { customRender: "buyNum" },
        },
        {
          title: "订单金额(元)",
          dataIndex: "orderAmount",
          key: "orderAmount",
          align: "center",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: "orderAmount" },
        },
        {
          title: "优惠金额(元)",
          dataIndex: "discountAmount",
          key: "discountAmount",
          align: "center",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: "discountAmount" },
        },
        {
          title: "订单状态",
          dataIndex: "orderStatus",
          key: "orderStatus",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderStatus" },
        },
        {
          title: "支付方式",
          dataIndex: "payType",
          key: "payType",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "payType" },
        },
        {
          title: "购买日期",
          dataIndex: "createTime",
          align: "center",
          key: "createTime",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 80,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
    };
  },
  watch: {},
  activated() {
    //查询数据字典
    DictionaryService.getAllNeedDic([
      "ORDER_PAY_TYPE",
      "ORDER_STATUS",
      "ORDER_GOODS_TYPE",
    ]).then((res) => {
      this.orderPayTypes = DictionaryService.getOptions("ORDER_PAY_TYPE"); //支付方式
      this.orderStatuss = DictionaryService.getOptions("ORDER_STATUS"); //订单状态
      this.orderGoodsTypes = DictionaryService.getOptions("ORDER_GOODS_TYPE"); //套餐类型
      //查询列表
      this.queryDataFn();
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    // 详情跳转
    jumpDetailsFn(item) {
      this.$router.push({
        path: "/home/customer/register/service-plan-details",
        query: {
          custId: item.custId,
          id: item.id,
        },
      });
    },
    // 获取表格数据
    queryDataFn(sum = 2) {
      this.spinning = true;
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          accountName: this.accountName,
          pgName: this.pgName,
          orderStatus: this.orderStatus,
          payType: this.payType,
        },
      };
      qcpQuery(obj).then((res) => {
        this.tableData = res.content.rows;
        this.totalRows = res.content.page.totalRows;
        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        this.spinning = false;
      });
    },
    // 分页
    changePageFn(event) {
      this.pageNum = event;
      this.queryDataFn();
    },
    // 时间戳转化日期
    toDate(date) {
      if (date == null) {
        return "";
      } else {
        let date1 = new Date(date);
        let time = this.formatDate(date1);
        return time;
      }
    },
    formatDate(value) {
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}

/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,
.ant-select,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 236px;
}
.oper {
  // flex: 1;
  width: 200px;
}
.plan {
  width: 350px;
}
.ant-row {
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 75px;
}
/deep/ .fl3 .ant-row .ant-col-6:nth-child(1) {
  width: 80px;
}
/deep/ .ant-col-18 {
  width: 75%;
}
</style>
